import { createSwedishErrorMessage } from '@/helpers/errorMessages';
import SimpleLayoutWithLogo from '@/layout/SimpleLayout';
import { fetchReportForAnonymousUser } from '@/services/downloadService';
import { saveAs } from 'file-saver';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PrimaryButton } from 'ui';
import { Typography } from 'ui/mui';
import DownloadStatus from './DownloadStatus';
import { extractFilenameFromContentDisposition } from '@/helpers/downloadHelper';
const Download = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [downloadProgress, setDownloadProgress] = useState<number | undefined>(
    undefined,
  );
  const { token } = useParams<string>();

  const handleDownload = async () => {
    setErrorMessage(null);
    setSuccessMessage(null);
    setIsLoading(true);
    setDownloadProgress(0);

    if (!token) {
      setErrorMessage('Ingen token angiven i URL:en.');
      setIsLoading(false);
      return;
    }

    try {
      const response = await fetchReportForAnonymousUser(
        token,
        (progressEvent) => {
          const total = progressEvent.total || 1;
          const percentCompleted = Math.round(
            (progressEvent.loaded / total) * 100,
          );
          setDownloadProgress(percentCompleted);
        },
      );

      setIsLoading(false);
      setDownloadProgress(undefined);

      if (response.response.status === 200) {
        const filename = extractFilenameFromContentDisposition(
          response.response.headers.get('content-disposition') ?? '',
        );
        saveAs(response.data, filename || 'download');
        setSuccessMessage('Nedladdningen är klar!');
      } else {
        setErrorMessage(createSwedishErrorMessage(response.response.status));
      }
    } catch (error) {
      setIsLoading(false);
      setDownloadProgress(undefined);
      const status =
        error instanceof Error && 'status' in error
          ? (error.status as number | undefined)
          : undefined;
      setErrorMessage(
        status
          ? createSwedishErrorMessage(status)
          : 'Ett okänt fel inträffade. Försök igen senare.',
      );
    }
  };

  useEffect(() => {
    handleDownload();
  }, []);

  return (
    <SimpleLayoutWithLogo>
      <Typography
        variant='h1'
        component='h1'
        sx={{ color: 'primary.main' }}
        gutterBottom
      >
        Ladda ner rapporten
      </Typography>
      <Typography
        variant='h6'
        component={'p'}
        gutterBottom
        sx={{ maxWidth: '60ch' }}
      >
        Nedladdningen bör starta automatiskt. Om nedladdningen inte startar,
        klicka på knappen.
      </Typography>
      <PrimaryButton
        onClick={handleDownload}
        sx={{ my: 3 }}
        disabled={isLoading}
      >
        Ladda ner rapport
      </PrimaryButton>
      <DownloadStatus
        errorMessage={errorMessage}
        successMessage={successMessage}
        downloadProgress={downloadProgress}
      />
    </SimpleLayoutWithLogo>
  );
};

export default Download;
